module.exports = __webpack_public_path__ + "img/glasses-6.bb74fd8d.svg";